/*jshint esversion: 6 */

import firebase from 'firebase';
const state = {
  authUser: null,
  userSession: false,
  users: [],
  profile: [],
  user: null
};

const mutations = {

  setAuthUser(state, authUser) {
    //console.log ('mutation: setAuthUser')
    if (authUser === null || authUser == null || typeof authUser === 'undefined')
      state.userSession = false;
    else {
      state.userSession = true;
      state.authUser = authUser;
    }
    //console.log ('state.authUser: ' + state.authUser)    
    //console.log ('state.userSession: ' + state.userSession)   
  },
  loadUsers(state, Users) {
    state.users = Users;
  },
  loadUser(state, user) {
    state.user = user;
  },
  setProfile(state, profile) {
    state.profile = profile;
  },
  approveUser(state, user) {
    //not done   
    //console.log('userid: ' + userid)

    const index = state.users.findIndex(function (userx) {
      return userx.id === user.id;
    });
    if (index > -1) {

      state.users[index].approved = user.approved;
      state.users[index].admin = user.admin;
      state.users[index].active = user.active;
    }
    //console.log('user.id' + user.id)
    //console.log('state.profile.id' + state.profile.id)
    if (user.id === state.profile.id) {
      state.profile.approved = user.approved;
      state.profile.admin = user.admin;
      state.profile.active = user.active;
    }

  },
  setAccountApproved(state, approved) {

    state.showAlertApprove = approved;
  },
  // unapproveUser (state, props) {
  //   //not done
  //   state.users = props    
  // },
  inactivateUser(state, user) {
    const index = state.users.findIndex(function (userx) {
      return userx.id === user.id;
    });
    if (index > -1) {
      //console.log('user deleted: ' + state.users[index].name)
      state.users[index].name = 'Bruger ikke fundet';
      //add a isDeleted to hide user but keep the record...
    }
  },
};

const actions = {
  loadUserById(context, userid, {
    vm
  }) {
    const db = vm.$firebase.firestore();

    db.collection('users').where('user_id', '==', userid)
      .get().then(res => {
        let user = null;
        res.docs.forEach(doc => {
          user = doc.data();
          user.id = doc.id;
        });
        context.commit('loadUser', user);

      });
  },
  setAuthUser(context) {

    firebase.auth().onAuthStateChanged((userAuth) => {
      //console.log ('in setAuthUser action')
      context.commit('setAuthUser', userAuth);

    });
  },
  setAccountApproved(context) {
    if (state.profile.approved)
      context.commit('setAccountApproved', false);
    else
      context.commit('setAccountApproved', true);
  },
  setProfile(context, {
    vm
  }) {
    //console.log('user.js setProfile')
    const db = vm.$firebase.firestore();
    let profile = [];
    db.collection('users')
      .where('user_id', '==', vm.$store.getters.authUser.uid)
      .get().then(res => {

        res.docs.forEach(doc => {
          profile = doc.data();
          profile.id = doc.id;
          profile.email = vm.$store.getters.authUser.email;
          profile.password = vm.$store.getters.authUser.password;


        });
        context.commit('setProfile', profile);
        // resolve(console.log('setProfile promise resolved'))  
        //})
        //.catch(reject(console.log('setProfile promise rejected'))) 
      });

  },
  inactivateUser(context, props) {
    //console.log('delete user!' + props.name)
    const db = props.vm.$firebase.firestore();

    //update database
    db.collection('users').doc(props.user.id).set({
      name: props.user.name,
      user_id: props.user.user_id,
      approved: false,
      admin: false,
      active: false
    }).then(() => {

      context.commit('inactivateUser', props);
    });
  },

  approveUser(context, props) {
    //console.log('props.user.admin' + props.user.admin)
    //console.log('props.user.delete' + props.user.delete)


    const db = props.vm.$firebase.firestore();
    db.collection('users').doc(props.user.id).set({
      name: props.user.name,
      user_id: props.user.user_id,
      approved: props.user.approved,
      admin: props.user.admin,
      active: props.user.active,
      created: props.user.created
    }).then(() => {
      context.commit('approveUser', props.user);
    });

  },

  loadUsers(context, {
    vm
  }) {
    const db = vm.$firebase.firestore();
    const users = [];
    db.collection("users").onSnapshot(snapshot => {
      let changes = snapshot.docChanges();
      changes.forEach(change => {
        if (change.type == 'added') {
          users.push({
            id: change.doc.id,
            name: change.doc.data().name,
            user_id: change.doc.data().user_id,
            approved: change.doc.data().approved,
            admin: change.doc.data().admin,
            active: change.doc.data().active,
            created: change.doc.data().created

          });
        }
      });
      context.commit('loadUsers', users);
      console.log("#loadUsers done#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() ); 
    });
  },
};

const getters = {
  authUser: state => {
    return state.authUser;
  },
  users: state => {
    return state.users;
  },
  user: state => {
    return state.user;
  },
  profile: state => {
    return state.profile;
  },
  userSession: state => {
    return state.userSession;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};